// Default seed for the R-value (위험지수) threshold card. PRD 09 §3.4 기본 시드.
// Used by the 초기화 (reset) button — client-only, no API call. These are the INITIAL
// configuration only; admins may save any valid values afterwards.
//
// SHCT-681 — the seed is PRD §3.4's own, verbatim, and it is also what the server seeds the table
// with (V70__admin_biometric_risk_band.sql). It was briefly shifted to shared boundaries
// (…~6.0 / 6.0~…) to satisfy a strict-equality reading of the continuity rule; that reading is gone
// (see risk-range.schema.ts), and with the 0.1-step reading these values validate as written — which
// they must, since 초기화 → 저장 has to be a save the server accepts.

import type { RiskRange } from '../types/risk-range.types';

export const DEFAULT_RISK_RANGE: RiskRange = {
  low: { min: 0.0, max: 5.9 },
  mid: { min: 6.0, max: 14.4 },
  high: { min: 14.5, max: 26.8 },
};

// Inputs accept one decimal place. There is NO absolute upper bound: per clarification
// ADM.024 (2026-07-07) the R-score is a running sum that can exceed 26.8 as PRO items grow,
// so only the lower bound (>= 0.0) is enforced. This supersedes the PRD's "0~26.8 운영 범위"
// wording and the prototype's absMax 100.0.
export const RISK_RANGE_STEP = 0.1;
export const RISK_RANGE_ABS_MIN = 0.0;

// Section order for iterating fields / rendering. PRD 09 §2.2 items 13–15.
export const RISK_INTERVAL_KEYS = ['low', 'mid', 'high'] as const;
export const RISK_BOUND_KEYS = ['min', 'max'] as const;
